<template>
  <div class="bodys" v-if="body_show">
    <!-- 我的头部 -->
    <public-top :headimgurl="headimgurl" :nickname="nickname"></public-top>
    <div class="ban_main">
      <ul>
        <li v-for="(item,index) in list" :key="index" :class="index == (list.length-1)?'last':''">
          <router-link :to="{path:'/edit',query:{cid:cid,id:item.id,title:item.title}}">
              {{item.title}}
              <img src="../../../assets/href.png" />
            </router-link>
        </li>
      </ul>
    </div>
    <!-- 公用底部 -->
    <public-footer :childMsg="1"></public-footer>
  </div>
</template>
<script>
import {
  index
} from "@/api/person"
import {
  shareCon
} from "@/utils/wxconfig";
export default {
  data() {
      return {
        body_show: false,
        headimgurl: "",
        nickname: "",
        list: [],
        cid: ""
      };
    },
    methods: {
      pullData() {
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        index().then(data => {
          this.body_show = true;
          this.$toast.clear();
          this.cid = this.$route.query.cid;
          this.headimgurl = data.userinfo.headimgurl;
          this.nickname = data.userinfo.nickname;
          this.list = data.list;
        });
      }
    },
    created() {
      this.pullData();
      shareCon("index",this);
    }
};
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.bodys {
  text-align: center;
  padding-bottom: 120px
}

.ban_main {
  width: 100%;
  padding-left: changeRem(.6) + px;
  margin-top: changeRem(.6) + px;
  background: #fff;
  li {
    line-height: changeRem(1.8) + px;
    border-bottom: 2px solid #ccc;
    color: #333;
    font-size: changeRem(.68) + px;
    padding-right: changeRem(.6) + px;
    text-align: left;
    cursor: pointer;
    a {
      display: block;
      width: 100%;
      height: 100%;
      color: #333;
      img.chece {
        width: changeRem(1.6) + px;
        height: changeRem(1.6) + px;
        margin-top: changeRem(.1) + px;
        margin-right: changeRem(1) + px;
      }
    }
    img {
      float: right;
      width: changeRem(.56) + px;
      vertical-align: middle;
      margin-top: changeRem(.6) + px;
    }
  }
  li.last {
    border-bottom: none
  }
}
</style>
